import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    container: {
        height: 'auto',
        minHeight: '150px',
        margin: '8px 0',
        padding: '12px',
        position: 'relative'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    },
    title: {
        fontWeight: 'bold'
    },
    iconsContainer: {
        position: 'absolute',
        right: 0
    },
    textFieldContainer: {
        display: 'grid',
        alignItems: 'center',
        // justifyContent: 'space-between'
        gridTemplateColumns: '4fr 5fr'
    },
    textFieldContainerLast: {
        marginBottom: theme.spacing(2)
    },
    textField: {
        // width: '160px',
        fontSize: '14px',
        '& .MuiInputBase-root': {
            fontSize: '14px',
        }
    },
    additionalInfoContainer: {
        width: '92%',
        // marginTop: '40px',
        // position: 'absolute',
        // bottom: '12px'
    },
    subtitle: {
        fontSize: '14px'
    },
    sendButton: {
        display: 'flex',
        justifyContent: 'center',
        width: '120px',
        height: '32px',
        margin: '0 auto 12px'
    },
    historyContainer: {
        display: 'flex',
        width: '100%',
        height: '32px',
        justifyContent: 'space-between'
    },
    btnHistory: {
        width: '32px'
    },
    btnFinalizaded: {
        backgroundColor: 'green',
        color: 'white',
        '&:hover': {
            backgroundColor: 'green'
        }
    }
}))